<template>
  <div>
    <div>
      <img class="picture" src="../../assets/pictures/robot02.jpg" alt="" />
    </div>
    <div class="test00">
      <div>
        <img class="pic1" src="../../assets/pictures/Test.png" alt="" />
      </div>
      <div class="test table-wrapper">
        <el-table
          id="pdfDom"
          :data="robot01list"
          :show-header="false"
          :row-style="{height: '90px'}"
          style="font-size: 25px"
        >
          <el-table-column label="变量" prop="VariableName"></el-table-column>
          <el-table-column label="值" prop="Value" align="center">
            <template slot-scope="scope">
              <div :style="{color: scope.row.isOverText ? '#00e676' : '#00e676'}">
                {{ scope.row.Value }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    data () {
        return {
            getTypeList: {
                page: '1',
                limit: '5',
                privateKey: '12a5081e-e354-bada-3952-7a0df30d8849',
                appIdentification: 'wms',
                code1: 'MobileRobot'
            },
            storageNumberList: [],
            robot01list: []
        }
    },
    methods: {
        //调用接口获取仓库储位信息
        async getRobot01 () {
            let params = new URLSearchParams();
            params.append("code", this.getTypeList.code1)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            const { data: res } = await this.$http.get('/WMS/queryVariable', { params })
            console.log(res)
            if (res.code !== 0) {
                return this.$message.error('获取机器人轴关节数据失败！')
            }
            console.log(res.data)
            this.robot01list = res.data
        },
    },
    created () {
        this.getRobot01()
    },
    mounted () {
        this.timer = setInterval(() => {
            this.getRobot01()
        }, 2000);
        this.$once('hook:beforeDestroy', () => {
            clearInterval(timer);
        })
    },
    beforeDestroy () {
        clearInterval(this.timer);
        this.timer = null;
    },

}
</script>

<style lang="less" scoped>
.picture {
  background-size: 100% 100%;
  position: fixed;
  width: 100%;
  height: 100%;
}
.test {
  width: 40%;
  height: 20%;
  position: absolute;
  left: 79%;
  top: 36%;
  transform: translate(-50%, -50%);
}
/**表格背景透明 */
//透明化整体
.table-wrapper /deep/ .el-table,
.el-table__expanded-cell {
  background-color: transparent !important;
}
//透明化行、单元格,删除表头下横线
.table-wrapper /deep/ tr,
.table-wrapper /deep/ th,
.table-wrapper /deep/ td {
  background: transparent !important;
  color: #fff;
  border-bottom: 0px; //删除表头下横线
}
//hover时样式
.table-wrapper /deep/ .el-table tbody tr:hover > td {
  background-color: transparent !important;
}
// 表格内容(有用)
.table-wrapper /deep/ .el-table__row {
  background: transparent !important;
  color: transparent;
}
.table-wrapper ::v-deep .el-table::before {
  left: 0;
  bottom: 0;
  width: 100%;
  height: 0px;
}
.table-wrapper ::v-deep .el-table td {
  border-bottom: 0px solid #dfe6ec !important;
}
.pic1 {
  width: 30%;
  position: absolute;
  left: 25%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>
